import { Route, Routes } from "react-router-dom";
import { ExceptionList } from "./list";
import { CreateExceptionTaxRoutes } from "./list/create";

export default function ExceptionTaxRoutes() {
  return (
    <Routes>
      <Route path="/" element={<ExceptionList />} />
      <Route path="/criar-excecao" element={<CreateExceptionTaxRoutes />} />
    </Routes>
  );
}
